import { FunctionComponent, ReactNode, useContext } from 'react'
import styled, { css } from 'styled-components'
import contextStandardTeaser from '@contexts/standardTeaser'
import { StandardTeaserLayoutContextType } from '@contexts/standardTeaser'
import { desktopCSS, tabletCSS, mobileCSS } from '@measures/responsive'

type StyledOuterWrapperProps = Pick<
  StandardTeaserLayoutContextType,
  'isInMegaModule'
>

const { StandardTeaserLayoutContext } = contextStandardTeaser

const StyledOuterWrapper = styled.div<StyledOuterWrapperProps>`
  ${({ isInMegaModule }) => {
    let notMobileStyle
    if (isInMegaModule) {
      notMobileStyle = css`
        grid-template-columns: auto minmax(0, 1fr);
      `
    } else {
      notMobileStyle = css`
        grid-template-rows: auto minmax(0, 1fr);
      `
    }

    const mobileStyle = css`
      grid-template-columns: auto minmax(0, 1fr);
    `

    return css`
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: grid;

      ${desktopCSS(css`
        ${notMobileStyle}
      `)}

      ${tabletCSS(css`
        ${notMobileStyle}
      `)}

      ${mobileCSS(css`
        ${mobileStyle}
      `)}
    `
  }}
`

const OuterWrapper: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => {
  const { isInMegaModule } = useContext(StandardTeaserLayoutContext)

  return (
    <StyledOuterWrapper
      className="outerwrapper"
      isInMegaModule={isInMegaModule}>
      {children}
    </StyledOuterWrapper>
  )
}

export default OuterWrapper
